import { types } from "mobx-state-tree";

import { ValidationMesssageModel } from "../ValidationMesssage";
import { ValidatorModel } from "../Validator";
import { isAfter, isEqual } from "date-fns";

export const TimeframeDateModel = types.model({
  date: types.frozen(),
  fieldName: types.string,
});

const TimeframeModel = types
  .model({
    startDate: types.maybeNull(TimeframeDateModel),
    endDate: types.maybeNull(TimeframeDateModel),
  })
  .actions((self) => ({
    setTimeFrame(startDate: any, endDate: any) {
      self.startDate = startDate;
      self.endDate = endDate;
    },
  }));

export const TimeframeValidatorModel = types
  .compose(ValidatorModel, TimeframeModel)
  .actions((self) => ({
    validate() {
      if (isAfter(self.endDate?.date, self.startDate?.date) ||
        isEqual(self.endDate?.date, self.startDate?.date)) {
        return undefined;
      }

      return ValidationMesssageModel.create({
        message: { mainKey: "general.validation.value2.greater-than.value1" },
        context: {
          value1: self.startDate?.fieldName,
          value2: self.endDate?.fieldName,
        },
      });
    },
  }));
